// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FeatureContainer_wrapper__yPoHf","title":"FeatureContainer_title__8hDvR","description":"FeatureContainer_description__a9fwI"};